import axios from './interceptor'
import { baseUrl, nodeApiUrl } from './config'
import * as _ from 'lodash'
import { getStorage, setStorage } from '../../store/localStorage'
import loggerService from 'services/logger'

function removeInvalidOptions (merchant, items) {
  const menuOptions = getStorage('menuoptions')
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const itemClone = _.clone(item)
    item.options = (item.options || []).filter((o) => {
      const validOption = menuOptions[`${item.menuID}|${o.optionID}`] || menuOptions[`${item.setMenuID}|${o.optionID}`]
      if (!validOption) {
        let menuoptionsListStatus = 'menuoptoinList:'
        try {
          menuoptionsListStatus = Object.keys(menuOptions).join(',')
        } catch (error) {
          menuoptionsListStatus = `menuoptionsList:error:${error.message}`
        }
        console.error({
          merchantID: merchant.id,
          item: itemClone,
          option: o,
          optionMenuID: `${item.menuID}|${o.optionID}`,
          optionSetMenuID: `${item.setMenuID}|${o.optionID}`,
          menuoptionsListStatus,
          logType: 'invalid menu option',
        })
      }
      console.log('menuoptions', {
        logType: 'menu options',
        validOption,
        menu: itemClone,
        option: o,
        optionMenuID: `${item.menuID}|${o.optionID}`,
        optionSetMenuID: `${item.setMenuID}|${o.optionID}`,
      })
      return validOption
    })
  }
}
window.wingtesting = () => {
  const { basket, orders } = getStorage('state')
  const merchantId = basket.merchantId
  removeInvalidOptions({ id: merchantId }, window.extractOrderItems({ items: orders }))
}

function updateRemarks (merchant, items) {
  const remarks = getStorage('remarks')
  const merchantRemarks = _.get(remarks, merchant.id, []).concat(
    _(items).map((o) => o.remarks).filter((o) => o).flatten().uniq().value(),
  )
  _.set(remarks, merchant.id, merchantRemarks)
  setStorage('remarks', remarks)
}

export default {
  async listOrders (merchantId, isFilteredByMe = false, limit) {
    const res = await axios.get(`${baseUrl}/c/order`, {
      params: {
        me: isFilteredByMe,
        merchantID: merchantId,
        page: 1,
        size: limit || 10,
      },
    })
    return res.data
  },

  async getOrder (id) {
    const res = await axios.get(`${baseUrl}/c/order/${id}`)
    return res.data
  },

  async createOrder ({ merchantID, table, isDelivery, isStoreDelivery, memberID }) {
    const res = await axios.post(`${baseUrl}/c/order`, {
      merchantID,
      table,
      isDelivery,
      isStoreDelivery,
      memberID,
    })
    return res.data
  },

  async joinOrder (id) {
    const res = await axios.post(`${baseUrl}/c/order/${id}/join`)
    return res.data
  },

  async addOrderItem (id, item) {
    const res = await axios.post(`${baseUrl}/c/order/${id}/item`, item)
    return res.data
  },

  async removeOrderItem (id, itemId) {
    const res = await axios.delete(`${baseUrl}/c/order/${id}/item/${itemId}`)
    return res.data
  },

  async lockOrder (id, uuid) {
    const res = await axios.post(`${baseUrl}/c/order/${id}/lock`, {
      batchID: uuid,
    })
    return res.data
  },
  async submitOrder ({ id, uuid, items, remark, promoCode, isTakeout, merchant, ignoreUnavailable }) {
    removeInvalidOptions(merchant, items)
    const res = await axios.post(
      `${baseUrl}/c/order/${id}/submit`,
      {
        batchID: uuid,
        items: items,
        remark: remark,
        isTakeout: isTakeout,
        promoCode: promoCode,
        ignoreUnavailable,
        from: 'CUSTOMER_WEB',
      },
      {
        retry: 3,
        shouldRetry: (err) => {
          if (err.config.currentRetryAttempt >= err.config.retry) {
            return false
          }
          return !err.response
        },
      },
    )
    loggerService.flush()
    // setStorage('menuoptions', {})
    updateRemarks(merchant, items)
    return res.data
  },
  async submitTakeawayOrder ({
    id,
    uuid,
    remark,
    takeawayInfo,
    promoCode,
    merchant,
    deliveryType,
    ignoreUnavailable,
    items,
    shipping,
    needTableware,
    card,
    payment,
  }) {
    removeInvalidOptions(merchant, items)
    const res = await axios.post(`${baseUrl}/c/order/${id}/submit`, {
      preSubmit: false,
      batchID: uuid,
      items,
      remark,
      takeawayInfo,
      promoCode,
      deliveryType,
      ignoreUnavailable,
      shipping,
      needTableware,
      card,
      payment,
    })
    loggerService.flush()
    // setStorage('menuoptions', {})
    updateRemarks(merchant, items)
    return res.data
  },
  async submitDineinPayment (id, params) {
    console.log(id)
    console.log(params)

    const res = await axios.put(`${baseUrl}/c/order/${id}/dineinpay`, params)
    return res.data
  },

  async payOrder (id, payment) {
    const res = await axios.put(`${baseUrl}/c/order/${id}/pay`, {
      payment: payment,
    })
    return res.data
  },

  async requestService (id) {
    const res = await axios.put(`${baseUrl}/c/order/${id}/service`, {})
    return res.data
  },

  async getRecentPaymentInfo () {
    const res = await axios.get(`${baseUrl}/c/payment/recent`, {})
    return res.data
  },

  async completeTakeawayOrder (orderId, code, token) {
    const res = await axios.put(`${baseUrl}/c/order/${orderId}/complete`, { code }, { headers: { Authorization: 'TOKEN ' + token } },
    )
    return res
  },

  async makeWechatPayment (body) {
    const res = await axios.post(`${nodeApiUrl}/payment/qfpay/wechatpay`, body)
    return res.data
  },

  async getWechatOrderStatus (orderId) {
    const res = await axios.get(`${nodeApiUrl}/payment/qfpay/enquiry/${orderId}`, {})
    return res.data
  },

  async saveCache (key, data, token) {
    const res = await axios.post(`${nodeApiUrl}/c/cache/${key}`, data, {
      headers: { Authorization: 'TOKEN ' + token },
    })
    return res.data
  },

  async loadCache (key, token) {
    const res = await axios.get(`${nodeApiUrl}/c/cache/${key}`, {
      headers: { Authorization: 'TOKEN ' + token },
    })
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/order.js